import { Component, OnInit } from '@angular/core';

import { Form, FormMode } from '../../../base/form';
import { FormControl, FormGroup } from '@angular/forms';
import { ContractService } from '../../../services/contract.service';
import { blank, filled } from '../../../shared/utils/common';
import { cloneDeep, get } from 'lodash-es';
import { NotificationService } from '../../../services/notification.service';
import { LooseObject } from '../../../objects/loose-object';
import { RecordService } from '../../../services/record.service';
import { Select } from '../../../objects/select';
import { FormService } from '../../../services/form.service';
import { TranslateService } from '@ngx-translate/core';
import { sprintf } from 'sprintf-js';
import { Relate } from '../../../objects/relate';
import { filter, first, switchMap, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { EditRecurringJobsComponent } from '../../../shared/components/widget/recurring-jobs/edit-recurring-jobs/edit-recurring-jobs.component';
import moment from 'moment';
import { AuthService } from '../../../auth/auth.service';
import { RecurringJobsService } from '../../../services/recurring-jobs.service';
import { ViewService } from '../../../services/view.service';
import { UUID } from 'angular2-uuid';
import { ContractRecurringJobsAssetTypeComponent } from './asset-types/asset-types.component';

@Component({
  selector: 'app-contract-recurring-jobs',
  templateUrl: './contract-recurring-jobs.component.html',
  styleUrls: ['./contract-recurring-jobs.component.scss'],
  providers: [
    RecurringJobsService
  ]
})
export class ContractRecurringJobsComponent implements OnInit {

  strMode: string = 'view';

  strModule: string = '';

  strModuleId: string = '';

  bSubmit: boolean = false;

  bHasChecklistInspection: boolean = false;

  objParentForm: FormGroup;

  bInvoiceFormLoading: boolean = false;

  objMetadata: LooseObject = {};

  objAssetType = new Relate<Select[]>();

  objSite = new Relate<Select[]>();

  arChecklistInspection: LooseObject[] = [];

  arSelectedSites: LooseObject[] = [];

  arAssetTypeChecklist: LooseObject[] = [];

  arAssetTypeList: LooseObject[] = [];

  bLoadingAssetType: boolean = true;

  bShowRelatedRecurringJob: boolean = false;

  objCurrentUser: LooseObject = {};

  get isForm(): boolean {
    return this.strMode == 'edit' || this.strMode == 'add';
  }

  get isEdit(): boolean {
    return this.strMode == 'edit';
  }

  get isView(): boolean {
    return this.strMode == 'view';
  }

  get displayList(): boolean {
    return this.strMode == 'edit' || this.strMode == 'view';
  }

  constructor(
    private contractService: ContractService,
    private notificationService: NotificationService,
    private recordService: RecordService,
    private formService: FormService,
    private translateService: TranslateService,
    private matDialog: MatDialog,
    private authUser: AuthService,
    private recurringJobsService: RecurringJobsService,
    private viewService: ViewService,
  ) {

  }

  ngOnInit() {
    this.objCurrentUser = this.authUser.getCurrentUser();

    if (this.displayList) {
      this._setUpRecurringJobListing();
      this.getExistingRecurringJob();
    } else {
      this.bLoadingAssetType = false;
    }

    if (this.isForm) {
      let arDefaultSite = [];
      if (this.viewService.strRecordModule == 'sites') {
        arDefaultSite = [
          new Select(
            get(this.viewService.arRecord, 'id'),
            get(this.viewService.arRecord, 'address_summary'),
          )
        ]
      }
      this.objAssetType.buildRelates(
        switchMap(strTerm => this.recordService.getRecordRelate('asset_types', strTerm, '', false))
      );
      this.objSite.buildRelates(
        switchMap(strTerm => this.recordService.getRecordRelate(
          'contract_sites',
          strTerm,
          '',
          false,
          {
            type: 'sites',
            ...( this.isEdit && {
              contract_id: this.strModuleId
            })
          }
        )),
        filled(arDefaultSite) ? arDefaultSite : [],
        filled(arDefaultSite)
      );
      this._getRecurringJobConfig();
    }
  }

  /**
   * @inheritdoc
   */
  setFormMode(mode: FormMode): void {
    this.strMode = mode;
  }

  /**
   * @inheritdoc
   */
  setParentForm(parentForm: FormGroup): void {
    this.objParentForm = parentForm;
  }

  /**
   * @inheritdoc
   */
  setField(field: Form<any>): void {
  }

  /**
   * remove the existing checklist inspection
   *
   * @param objAssetType
   */
  removeChecklistInspection(siteIndex: number, assetTypeIndex: number): void {
    if (
      filled(this.arSelectedSites[siteIndex])
      && filled(this.arSelectedSites[siteIndex].asset_type_checklist[assetTypeIndex])
    ) {
      this.arSelectedSites[siteIndex].asset_type_checklist.splice(assetTypeIndex, 1);
    }
  }

  /**
   * retrieve existing recurring job linked on site or contract
   *
   * @param fromRelateField
   */
  getExistingRecurringJob(fromRelateField: boolean = false): void {
    let strSiteId = null;
    let strContractId = null;

    if (fromRelateField == true) {
      strSiteId = filled(this.objSite) && filled(this.objSite.value) ? this.objSite.value['id'] : null;
      if (blank(strSiteId)) {
        this.arAssetTypeList = [];
        this.bLoadingAssetType = false;
        this.bShowRelatedRecurringJob = true;
        return;
      }
    } else {
      strContractId = this.strModuleId;
    }

    this.arAssetTypeList = [];
    this.bLoadingAssetType = true;
    this.bShowRelatedRecurringJob = false;
    this.contractService.getRecurringJobPerAssetType(strSiteId, strContractId).subscribe( response => {
      this.bLoadingAssetType = false;
      this.arAssetTypeList = get(response, 'body');
    })
  }

  /**
   * edit recurring job
   *
   * @param recurringJob
   */
  editRecurringJob(recurringJob: LooseObject): void {
    let strRecurringJobId = get(recurringJob, 'id');
    if (filled(strRecurringJobId)) {

      this.matDialog.open(EditRecurringJobsComponent, {
          maxWidth: '100%',
          width: '80%',
          height: 'auto',
          disableClose: true,
          data: {
            record_id: null,
            module: null,
            recurring_job: recurringJob,
            recurring_job_id: strRecurringJobId,
            view_type: 'edit',
          },
        })
        .afterClosed()
        .pipe(
          first(),
          filter(response => filled(response) && response !== false),
          tap(() => this.getExistingRecurringJob(this.isForm)),
          tap(() => this.notificationService.notifySuccess('header_notification.success_update')),
        )
        .subscribe();
    }
  }

  /**
   * delete recurring job
   *
   * @param recurringJob LooseObject
   */
  deleteRecurringJob(recurringJob: LooseObject, siteIndex: number, assetTypeIndex: number): void {
    let strRecurringJobId = get(recurringJob, 'id');
    let intRecurringJobIndex = this.arAssetTypeList[siteIndex]['asset_types'][assetTypeIndex]['recurring_jobs'].findIndex( data => data.id == strRecurringJobId);
    if (filled(strRecurringJobId) && intRecurringJobIndex > -1) {
      this.notificationService.sendConfirmation('confirm_delete').pipe(
        filter((confirmation) => confirmation.answer == true ),
      ).subscribe( () => this.recordService.deleteRecord('recurring_jobs', strRecurringJobId)
        .pipe(
          first(),
        )
        .subscribe( response => {
          if (get(response, 'status') == 200) {
            this.notificationService.notifySuccess('record_delete_success');
            this.arAssetTypeList[siteIndex]['asset_types'][assetTypeIndex]['recurring_jobs'].splice(intRecurringJobIndex, 1);
          } else {
            let hasObjectResponse = (typeof response.body === 'object' && response.body['message']);
            this.notificationService.sendNotification(
              'warning',
              hasObjectResponse ? response.body['message'] : response.body.toString(),
              'warning'
            );
          }
        }, error => {
          if (error.error.id) {
            this.notificationService.sendNotification('not_allowed', error.error.id[0], 'warning');
          }
        })
      );
    }
  }

  formatRepeated(data: string) {
    return this.recurringJobsService.formatRepeatedEvery(data);
  }

  formatDate(date): string {
    if (blank(date)) {
      return '';
    }
    return moment(date).format('LL');
  }

  openAssetType(): void {
    const parentData = this.recordService.getParentData();
    const parentId = get(parentData, 'id');
    const parentModule = get(parentData, 'module');

    this.recordService.getRecordBasedOnParent(true).subscribe( data => {
      let objDialogConfig = this.recordService.compilePopUpConfig({
        record_details: get(data, 'record_details', {}),
        metadata: this.objMetadata,
        site_id: parentModule == 'sites' ? parentId : null,
        customer_id: parentModule == 'customers' ? parentId : null,
        contract_id: parentModule == 'contracts' ? parentId : null,
      });
      objDialogConfig.width = '40%';

      this
        .matDialog
        .open(ContractRecurringJobsAssetTypeComponent, objDialogConfig)
        .afterClosed()
        .subscribe( response => {
          if (filled(response)) {
            const objChecklist = get(response, 'checklists');
            Object.keys(objChecklist).forEach( strChecklistId => {
              const checklist = objChecklist[strChecklistId];
              this._setupSelectedRepeatingGroup({
                  id: get(checklist, 'asset_type_id'),
                  text: get(checklist, 'asset_type_text'),
                },
                objChecklist[strChecklistId],
                get(response, 'sites'),
                get(response, 'next_job_date'),
              );
            });

            if (!this.isForm) {
              let objRecordConfig = this.viewService.objRecord;
              let objRecordData = get(objRecordConfig, 'record_details', {});
              let objPayload = {
                contract_recurring_jobs: this._formatSelectedAssetTypes()
              };

              Object.keys(objRecordConfig.used_fields).forEach( strFieldKey => {
                get(objRecordData, strFieldKey)
                if (filled(get(objRecordData, strFieldKey))) {
                  objPayload[strFieldKey] = objRecordData[strFieldKey]
                }
              });

              this.recordService.saveRecord('contracts', objPayload, objRecordData.id).subscribe( response => {
                this.notificationService.notifySuccess('record_create_success');
                this.getExistingRecurringJob();
              });
            }
          }
        });
    });

  }
  /**
   * retrieve recurring job config
   * update the metadata to used the centralise edit field component
   */
  private _getRecurringJobConfig(): void {
    this.recordService.getRecordConfig('recurring_jobs').subscribe( response => {
      this.objMetadata = {
        ...response['used_fields'],
        ...response['available_fields']
      };
      ['repeated_every', 'next_job_date', 'due_date', 'user_id', 'billable'].forEach( strKey => {
        let objDetails = {};

        this.objMetadata[strKey].key = strKey;
        this.objMetadata[strKey].hide_label = true;
        this.objMetadata[strKey].readonly = get(this.objMetadata[strKey], 'readonly', false);
        this.objMetadata[strKey].is_hidden = get(this.objMetadata[strKey], 'is_hidden', false);

        if (strKey === 'due_date') {
          this.objMetadata[strKey].default_value = 'last_day_of_this_month';
        }

        if (strKey === 'next_job_date') {
          this.objMetadata[strKey].type = 'date';
        }

        if (strKey === 'user_id') {
          this.objMetadata[strKey].default_value = get(this.objCurrentUser, 'id');
          objDetails['user_id'] = get(this.objCurrentUser, 'id');
          objDetails['user_text'] = get(this.objCurrentUser, 'display_text');
        }

        this.objMetadata[strKey] = this.formService.tranformFieldObject(this.objMetadata[strKey], objDetails);
      });
    });
  }

  /**
   * setup selected repeating group
   *
   * @param assetType
   * @param site
   * @param checklistInspection
   */
  private _setupSelectedRepeatingGroup(
    assetType: LooseObject,
    checklistInspection: LooseObject,
    siteRecord: LooseObject|null = null,
    nextJobDate: string|null = null,
  ): void {
    let arChecklistInspection = [];
    const arRepeatingGroup = get(checklistInspection, 'repeating_group', []);
    arRepeatingGroup.forEach( data => {
      if (data.is_checked) {
        let objFormGroup = new FormGroup({
          next_job_date: new FormControl(moment(nextJobDate)),
          due_date: new FormControl('last_day_of_this_month'),
          user_id: new FormControl(get(this.objCurrentUser, 'id')),
          billable: new FormControl(false),
        });
        arChecklistInspection.push({
          id: data.id,
          is_checked: true,
          prompt_name: data.prompt_name,
          asset_type_id: data.asset_type_id,
          repeated_every: data.repeated_every,
          form_group: objFormGroup,
          billable_id: UUID.UUID()
        });

        objFormGroup.valueChanges.subscribe( data => {
          this._syncRecord();
        })
      }
    });

    if (filled(arChecklistInspection)) {
      if (blank(siteRecord)) {
        siteRecord = {
          id: 'no_site',
          text: 'no_site',
        };
      }
      let intSiteIndex = this.arSelectedSites.findIndex( site => site.id == siteRecord.id );
      let objAssetTypeChecklist = {
        id: get(assetType, 'id'),
        name: get(assetType, 'text'),
        site_id: siteRecord.id,
        site_text: siteRecord.text,
        checklist_inspection: arChecklistInspection,
        is_checked: false,
      };
      if (intSiteIndex !== -1) {
        this.arSelectedSites[intSiteIndex].asset_type_checklist.push(objAssetTypeChecklist);
      } else {
        this.arSelectedSites.push({
          ...siteRecord,
          ...{
            asset_type_checklist: [
              objAssetTypeChecklist
            ]
          }
        });
      }
    } else {
      this.notificationService.notifyWarning(
        sprintf('%s %s', get(assetType, 'text'), this.translateService.instant('has_no_inspection_periods'))
      );
    }
  }

  /**
   * translate checklist inspection period
   */
  private _translatePeriod(period): string {
    const arPeriod = period.split('_');
    let strTranslatedPeriod = period;
    if (filled(arPeriod[1]) && typeof arPeriod[1] === 'string') {

      strTranslatedPeriod = sprintf('%s %s', arPeriod[0], this.translateService.instant(arPeriod[1]));
    }

    return strTranslatedPeriod;
  }

  /**
   * sync the update record to parent form
   */
  private _syncRecord(): void {
    let arChecklistInspection = this._formatSelectedAssetTypes();

    if (this.objParentForm) {
      this.objParentForm.controls.contract_recurring_jobs.setValue(arChecklistInspection);
    }
  }

  /**
   * get current view data
   */
  private _setUpRecurringJobListing(): void {
    const objRecord = this.recordService.getParentData();

    this.strModule = objRecord.module;
    this.strModuleId = objRecord.id;

    if (blank(this.strModuleId)) {
      const objForm = this.formService.getRecord('contracts');
      this.strModuleId = get(objForm, 'record_details.id');
    }
  }

  private _formatSelectedAssetTypes(): LooseObject[] {
    let arChecklistInspection = [];
    cloneDeep(this.arSelectedSites).forEach( site => {
      site.asset_type_checklist.forEach( assetType => {
        assetType.checklist_inspection.forEach( checklist => {
          if (checklist.is_checked) {
            let objForm = checklist.form_group.getRawValue();
            arChecklistInspection.push({
              asset_type_id: checklist.asset_type_id,
              job_summary: checklist.prompt_name,
              repeated_every: checklist.repeated_every,
              user_id: objForm.user_id,
              due_date: objForm.due_date,
              next_job_date: objForm.next_job_date,
              billable: objForm.billable,
              site_id: site.id,
            });
          }
        });
      });
    });

    return arChecklistInspection;
  }

}